import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class SharedService {
  private tempLocalStorage = localStorage.getItem('layout-dashboard');
  private currentDashboardSource = new BehaviorSubject<string>(this.tempLocalStorage === null || this.tempLocalStorage === undefined ? 'old' : this.tempLocalStorage);
  public currentDashboard$ = this.currentDashboardSource.asObservable();

  constructor() {
    this.currentDashboard$.subscribe(status => window.localStorage.setItem('layout-dashboard', status));
  }

  getChangeDashboard(): Observable<string> {
    let userStatus = window.localStorage.getItem('layout-dashboard');
    userStatus = (userStatus === 'old' || userStatus == null) ? 'new' : 'old';
    this.currentDashboardSource.next(userStatus);
    return this.currentDashboard$;
  }
}